import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: false,
  description: 'Sample Description',
};

export const ToastBoxSlice = createSlice({
  name: 'organizations',
  initialState,
  reducers: {
    setToastBoxStatus: (state, action) => {
      return {
        ...state,
        status: action.payload,
      };
    },
    setToastBoxDescription: (state, action) => {
      return {
        ...state,
        description: action.payload,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { setToastBoxStatus, setToastBoxDescription } = ToastBoxSlice.actions;

export default ToastBoxSlice.reducer;
